import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Dot } from "@/components/ui/dot";

import { useFeatureIslandCategoryContext, useFeatureIslandCategoryManagerContext } from "../../../context";

type Props = {
	onSetActiveCategoryID: (categoryID: string) => void;
};

export const FeatureIslandCategorySideMenuItemForMain = memo(({ onSetActiveCategoryID }: Props) => {
	const categoryID = useFeatureIslandCategoryContext((state) => state.categoryID);
	const title = useFeatureIslandCategoryContext((state) => state.title);
	const isEdited = useFeatureIslandCategoryContext((state) => state.isEdited);
	const hasError = useFeatureIslandCategoryContext((state) => state.hasError);

	const activeCategoryID = useFeatureIslandCategoryManagerContext((state) => state.activeCategoryID);

	const handleChangeActiveCategoryID = () => onSetActiveCategoryID(categoryID);

	return (
		<nav
			role="link"
			onClick={handleChangeActiveCategoryID}
			className={cn("cursor-pointer rounded p-2 text-sm text-zinc-500 hover:bg-zinc-100 hover:text-black", {
				"cursor-default bg-zinc-100 font-semibold text-black": activeCategoryID === categoryID,
			})}
		>
			<div className="flex items-center justify-between">
				<h5>{title}</h5>

				<div className="flex items-center gap-x-2">
					{isEdited && <Dot />}
					{hasError && <Dot variant="red" />}
				</div>
			</div>
		</nav>
	);
});
